import {
  CompaniesApi,
  CompanyCreationResponse,
  CreateCompanyInput,
  ReportAnalyticsChartsResponse,
  SettingType,
} from "../api/Companies";
import { buildMockPromise } from "../api/helpers";

export async function createCompanyMock(
  companyInput: CreateCompanyInput
): Promise<CompanyCreationResponse> {
  const response: CompanyCreationResponse = {
    external_id: "4b960f1d-440d-490d-a70f-ede902dbfad8",
    name: "wwww ddd",
    is_active: true,
    company_settings: [
      {
        external_id: "776fc29a-53b0-4703-a834-ba74b3a58590",
        setting_type_uuid: "3faed8d9-af9d-41b4-9fb9-cc2cbd6e05ad",
        value: "True",
      },
      {
        external_id: "776fc29a-53b0-4703-a834-ba74b3a58590",
        setting_type_uuid: "7336dcc6-7942-4f98-b530-4bb7c592ec86",
        value: "True",
      },
      {
        external_id: "776fc29a-53b0-4703-a834-ba74b3a58590",
        setting_type_uuid: "e7fa9a6c-d770-4230-bb82-6df5bd5268c4",
        value: "0",
      },
      {
        external_id: "776fc29a-53b0-4703-a834-ba74b3a58590",
        setting_type_uuid: "037bd401-424b-4a7f-84cb-82e5de616e13",
        value: "0",
      },
      {
        external_id: "776fc29a-53b0-4703-a834-ba74b3a58590",
        setting_type_uuid: "2026323a-17e8-48a0-a96d-3e26fe7ff214",
        value: "0",
      },
      {
        external_id: "776fc29a-53b0-4703-a834-ba74b3a58590",
        setting_type_uuid: "21a17448-224b-4b2a-ae8c-6e90c5792f1a",
        value: "True",
      },
      {
        external_id: "776fc29a-53b0-4703-a834-ba74b3a58590",
        setting_type_uuid: "b855c91c-8a96-442a-99b7-341269f5ca67",
        value: "qui non id elit",
      },
      {
        external_id: "776fc29a-53b0-4703-a834-ba74b3a58590",
        setting_type_uuid: "0c39a317-0d62-4b3f-9ec4-0fabe0887bb1",
        value: "qui non id elit",
      },
      {
        external_id: "776fc29a-53b0-4703-a834-ba74b3a58590",
        setting_type_uuid: "0aa8050a-7441-4763-9bdd-9efd9f623273",
        value: "qui non id elit",
      },
    ],
  };
  return await buildMockPromise(response);
}

export async function getCompanyBaseMock(
  companyUUID: string
): Promise<CompaniesApi> {
  return await buildMockPromise({
    external_id: "comp1f1f-4408-44ec-9fa4-db4b17fdbf60",
    is_active: true,
    name: `Company ${companyUUID}`,
    is_deleted: false,
    notes: `Company notes ${companyUUID}`,
    banner_notes: "",
    review: true,
    chat_support: true,
    instant_fit_subscriber: false,
    consent_forms: false,
  });
}

export async function getReportAnalyticsChartsMock(): Promise<ReportAnalyticsChartsResponse> {
  return await buildMockPromise({
    report_analytics_charts: true,
  });
}

export async function getSettingTypesMock(): Promise<SettingType[]> {
  const list = [
    {
      external_id: "a4b4ff34-3105-49c4-a48a-69752b60890c",
      default: "0",
      name: "LOOK_BACK_PERIOD",
      data_type: "INT",
      description: "Look back period (In months)",
    },
    {
      external_id: "3faed8d9-af9d-41b4-9fb9-cc2cbd6e05ad",
      name: "INTERCOM_ACCESS",
      default: "false",
      data_type: "BOOL",
      description: "Access to intercom",
    },
    {
      external_id: "7336dcc6-7942-4f98-b530-4bb7c592ec86",
      name: "SHOW_IMAGE_IN_REPORT",
      default: "true",
      data_type: "BOOL",
      description: "Show image in report",
    },
    {
      external_id: "e7fa9a6c-d770-4230-bb82-6df5bd5268c4",
      name: "USER_CREATION_LIMIT",
      default: "0",
      data_type: "INT",
      description: "User creation limit",
    },
    {
      external_id: "037bd401-424b-4a7f-84cb-82e5de616e13",
      name: "SUBCOMPANY_CREATION_LIMIT",
      default: "0",
      data_type: "INT",
      description: "Subcompany creation limit",
    },
    {
      external_id: "2026323a-17e8-48a0-a96d-3e26fe7ff214",
      name: "BLUEPRINT_CREATION_LIMIT",
      default: "0",
      data_type: "INT",
      description: "Blueprint creation limit",
    },
    {
      external_id: "21a17448-224b-4b2a-ae8c-6e90c5792f1a",
      name: "CAN_CREATE_COMPANY",
      default: "false",
      data_type: "BOOL",
      description: "Can create company",
    },
  ];
  return await buildMockPromise(list);
}
